export const MANAGEMENT_LANGUAGE = {
  management_addUser_name: "Name",
  management_addUser_name_error: "Please enter your name",
  management_addUser_name_length_error: "Character must be smaller than 50",
  management_addUser_email: "Email",
  management_addUser_email_error: "Please enter your email",
  management_addUser_contact_number: "Contact Number",
  management_addUser_contact_number_error: "Please enter your contact number",
  management_addUser_type: "Type",
  management_addUser_type_error: "Please select user type",
  management_addUser_status: "Status",
  management_addUser_status_error: "Please select user status",
  management_addUser_group: "Group",
  management_addUser_group_error: "Please select user group",
  management_upload_success_msg: "Upload Successful",
  management_upload_documents: "Documents",

  management_userListing_filter: "Filter",
  management_userListing_title: "User Management",
  management_userListing_view_name: "Name",
  management_userListing_view_role_column: "Role",
  management_userListing_view_email: "Email Address",
  management_userListing_view_number: "Number",
  management_userListing_view_userType: "User Type",
  management_userListing_view_roles: "Roles",
  management_userListing_view_status: "Status",
  management_userListing_view_role: "Select Roles",
  management_userListing_heading: "Roles & Permissions",
  management_userListing_view_action_bar_search: "Search",
  management_rolesListing_view_action_bar_search: "Search",
  management_rolesListing_name: "Roles",
  management_rolesListing_userType: "User type",
  management_rolesListing_heading: "Roles Management",
  management_rolesListing_permission: "Add Roles",
  management_rolesListing_permission_heading: "Roles & Permissions",
  management_rolesListing_permission_required_error: "Roles can't be empty",
  management_rolesListing_permission_name: "Role Name",
  management_roles_and_permission_name_err: "Please input user role name",
  management_roles_and_permission_name_max_length_err: "Role name must be smaller then 50 character",
  management_roles_and_permission_user_type_err: "Please input user type!",

  management_group_view_action_bar_search: "Search",

  management_cash_less_workshop_listing_title: "Cashless Workshops",
  management_cash_less_workshop_facility: "Facility",
  management_cash_less_workshop_facility_error: "Facility should not be greater than 100 characters",
  management_cash_less_workshop_name_space_error: "Name is invalid",
  management_cash_less_workshop_facility_space_error: "Facility is invalid",
  management_cash_less_workshop_address_space_error: "Address is invalid",
  management_list_management_groups_cash_less_workshop_title: "Cashless Workshops",
  management_cash_less_workshop_name_error: "Name is required",
  management_list_management_group_cash_less_workshops_number: "No. of Cashless Workshops",
  management_list_management_group_modal_select_cash_less_workshops: "Select Cashless Workshops",
  management_list_management_group_modal_selected_cash_less_workshop: "Selected Cashless Workshops",
  management_list_management_group_modal_cash_less_workshop: "Cashless Workshops",
  management_list_management_group_modal_select_cash_less_workshop_error: "Select Cashless Workshops Field is required",

  management_list_management_group_name: "Group Name",
  management_list_management_groups_hospital_title: "Groups(Hospitals)",
  management_list_management_groups_discount_center_title: "Discount Centers",
  management_list_management_group_hospitals_number: "No. of Hospitals",
  management_list_management_group_discount_centers_number: "No. of Discount Centers",
  management_list_management_group_cash_less_workshop_number: "No. of Workshops",
  management_list_management_group_modal_group_Name: "Group Name",
  management_list_management_group_modal_select_hospitals: "Select Hospitals",
  management_list_management_group_modal_select_discount_centers: "Select Discount Centers",
  management_list_management_group_modal_selected_hospitals: "Selected Hospitals",
  management_list_management_group_modal_selected_labs: "Selected Discount Centers",
  management_list_management_group_modal_hospitals: "Hospitals",
  management_list_management_group_modal_labs: "Discount Centers",
  management_list_management_group_modal_group_Name_error: "Group Name is required",
  management_list_management_group_name_space_error: "Group Name is invalid",
  management_list_management_group_modal_group_Name_length_error: "Group Name must be smaller than 50 Characters",
  management_list_management_group_modal_select_hospitals_error: "Select hospitals Field is required",
  management_list_management_group_modal_select_labs_error: "Select Discount Centers Field is required",
  management_hospital_listing_title: "Hospitals",
  management_hospital_listing_view_name: "Hospital Name",
  management_hospital_listing_view_name_error: "Hospital name is required",
  management_hospital_listing_view_name_length_error: "Character must be smaller than 50",

  management_hospital_view_action_bar_search: "Search",
  management_lab_listing_title: "Laboratory",
  management_discount_center_listing_title: "Discount Center",
  management_discount_center_facility: "Facility",
  management_discount_center_facility_error: "Facility should not be greater than 100 characters",
  management_discount_center_name_space_error: "Name is invalid",
  management_discount_center_facility_space_error: "Facility is invalid",
  management_discount_center_address_space_error: "Address is invalid",
  management_lab_listing_view_name: "Laboratory Name",
  management_lab_listing_view_name_error: "Name is required",
  management_lab_listing_view_name_length_error: "Character must be smaller than 50",

  management_lab_view_action_bar_search: "Search",

  management_coverages_listing_title: "Coverages",
  management_coverages_listing_coverage_name: "Coverage Name",
  management_coverages_listing_coverage_type: "Coverage Type",
  management_coverages_listing_coverage_parent: "Parent Coverage",
  management_coverages_listing_show_in_filter: "Show in Filter",
  management_coverages_view_action_bar_search: "Search",
  management_hospital_listing_view_last_update: "Last Update",

  management_make_listing_title: "Make",
  management_make_listing_add_title: "Add Make",
  management_make_listing_edit_title: "Edit Make",
  management_make_add_name: "Make",
  management_make_listing_make: "Make",
  management_make_add_name_error: "Make is required",
  management_make_add_make_length_error: "Make characters must be smaller than 50",
  management_make_view_action_bar_search: "Search",

  management_model_listing_title: "Model",
  management_model_listing_add_title: "Add Model",
  management_model_listing_edit_title: "Edit Model",
  management_model_add_make: "Make",
  management_model_add_model: "Model",
  management_model_listing_make: "Make",
  management_model_listing_model: "Model",
  management_model_add_make_error: "Make is required",
  management_model_add_model_error: "Model is required",
  management_model_add_model_length_error: "Model characters must be smaller than 50",
  management_model_view_action_bar_search: "Search",
  management_plan_type_listing_title: "Plan Type",
  management_add_plan_type_listing_title: "Add Plan Type",
  management_edit_plan_type_listing_title: "Edit Plan Type",
  management_coverages_listing_plan_type_name: "Plan Type",
  management_plan_type_listing_line_of_business: "Line of business",
  management_plan_type_listing_show_in_filter: "Show in Filter",
  management_plan_type_view_action_bar_search: "Search",

  management_variant_make: "Make",
  management_variant_model: "Model",
  management_variant_assembly: "Assembly",
  management_variant: "Variant",
  management_variant_name: "Variant Name",
  management_variant_add_title: "Add Variant",
  management_variant_edit_title: "Edit Variant",
  management_variant_year: "Year",
  management_variant_year_range: "Year Range",
  management_variant_year_start: "Starting Year",
  management_variant_year_end: "Ending Year",
  management_variant_new_used: "New/Used",
  management_variant_value: "Value",
  management_variant_car_value: "Car Value",
  management_variant_add_make_error: "Make is required",
  management_variant_add_model_error: "Model is required",
  management_variant_add_variant_error: "Variant is required",
  management_variant_add_assembly_error: "Assembly is required",
  management_variant_add_car_value_error: "Car Value is Required",
  management_variant_add_car_value_max_length_error: "Car Value must be of 9 digits",
  management_variant_add_car_value_type_error: "Car Value Type is Required",
  management_variant_add_car_type_error: "Car Type is Required",
  management_variant_add_start_year_error: "Start year is Required",
  management_variant_add_end_year_error: "End year is Required",
  management_variant_add_variant_length_error: "Variant characters must be smaller than 50",
  management_variant_new: "New",
  management_variant_used: "Used",
  management_variant_add_variant_car_value_type_required_error: "Car Value Type is missing",
  management_variant_add_variant_car_value_negative_error: "Negative Values are not allowed",
  management_variant_add_variant_start_year_greater_than_end_year_error: "Start Year cannot be greater than end year",

  management_variant_import_variants: "Import Variant",
  management_variant_import_variants_document_error_found: " errors have been found. ",
  management_variant_import_variants_document_click_here: " Click Here ",
  management_variant_import_variants_document_error_download_file: " to Download the file.",
  management_variant_import_variants_document_required_error: "Import document is required",

  management_assembly_listing_title: "Assembly",
  management_assembly_add_assembly_title: "Add Assembly",
  management_assembly_edit_assembly_title: "Edit Assembly",
  management_assembly_add_assembly: "Assembly",
  management_assembly_listing_assembly: "Assembly",
  management_assembly_add_assembly_error: "Assembly is required",
  management_assembly_add_assembly_length_error: "Assembly characters must be smaller than 50",
  management_assembly_add_assembly_name_format_error: "Assembly should not contain any special characters or number",
  management_assembly_view_action_bar_search: "Search",

  management_model_add_assembly: "Assembly",
  management_model_listing_assembly: "Assembly",
  management_model_add_assembly_error: "Assembly is required",
  management_make_import_makes: "Import Make",
  management_make_import_makes_document_error_found: " errors have been found. ",
  management_make_import_makes_document_click_here: " Click Here ",
  management_make_import_makes_document_error_download_file: " to Download the file.",
  management_make_import_makes_document_required_error: "Import document is required",

  management_model_import_models: "Import Model",
  management_model_import_models_document_error_found: " errors have been found. ",
  management_model_import_models_document_click_here: " Click Here ",
  management_model_import_models_document_error_download_file: " to Download the file.",
  management_model_import_models_document_required_error: "Import document is required",

  management_exclusion_listing_title: "Exclusions",
  management_exclusion_LOB: "Line of Business",
  management_exclusion_name: "Exclusion Name",
  management_exclusion_description: "Description",
  management_exclusion_coverage_type: "Coverage Type",
  management_exclusion_last_update: "Last Update",
  management_exclusion_add_text: "Add",
  management_exclusion_view_action_bar_search: "Search",
  management_exclusion_name_length_error: "Name must be smaller than 50 characters",
  management_exclusion_description_length_error: "Description must be smaller than 500 characters",

  management_coverage_add_coverage_name: "Coverage Name",
  management_coverage_add_coverage_name_error: "Coverage Name is required",
  management_coverage_add_coverage_length_error: "Coverage characters must be smaller than 50",
  management_coverages_add_coverage_type: "Coverage Type",
  management_coverages_add_coverage_type_error: "Coverage Type is required",
  management_coverages_add_select_parent: "Select Parent",

  management_plan_type_add_name: "Plan Type Name",
  management_plan_type_add_name_error: "Plan Type Name is required",
  management_plan_type_add_length_error: "Character must be smaller than 50",

  management_taxation_listing_title: "Taxation",
  management_taxation_listing_tax_on: "Tax On",
  management_taxation_listing_stamp_duty: "Stamp Duty",
  management_taxation_listing_fif: "FIF (%)",
  management_taxation_listing_sales_tax: "Sales Tax (%)",
  management_taxation_listing_withholding_tax_filer: "Withholding Tax % (Filer)",
  management_taxation_listing_withholding_tax_non_filer: "Withholding Tax % (Non-Filer)",
  management_taxation_add_title: "Taxation",
  management_taxation_add_tax_on: "Tax On",
  management_taxation_add_tax_on_error: "Tax On is required",
  management_taxation_add_stamp_duty: "Stamp Duty",
  management_taxation_add_stamp_duty_error: "Stamp Duty is required",
  management_taxation_add_stamp_duty_error_length: "Stamp Duty cannot be greater than 5 digits",
  management_taxation_add_stamp_duty_error_decimal_limit: "Stamp Duty can be up to 2 decimal places",
  management_taxation_add_stamp_duty_error_min_limit: "Stamp Duty must be greater than 0",
  management_taxation_add_stamp_duty_error_percentage_max: "Stamp Duty must be less than 100",
  management_taxation_add_fif: "FIF",
  management_taxation_add_fif_error: "FIF is required",
  management_taxation_add_fif_error_min: "FIF must be greater than 0",
  management_taxation_add_fif_error_max: "FIF must be less than 100",
  management_taxation_add_fif_error_decimal_limit: "FIF can be up to 2 decimal places",
  management_taxation_add_sales_tax: "Sales Tax",
  management_taxation_add_sales_tax_error: "Sales Tax is required",
  management_taxation_add_state_length_error: "Tax must be less than or equal to 100",
  management_taxation_add_state_error: "Tax is required",
  management_taxation_add_state_decimal_error: "Tax can be up to 2 decimal places",
  management_taxation_add_sales_tax_error_min: "Sales Tax must be greater than 0",
  management_taxation_add_sales_tax_error_max: "Sales Tax must be less than 100",
  management_taxation_add_sales_tax_error_decimal_limit: "Sales Tax can be up to 2 decimal places",
  management_taxation_add_withholding_tax_filer: "Withholding Tax (Filer)",
  management_taxation_add_withholding_tax_filer_error: "Withholding Tax (Filer) is required",
  management_taxation_add_withholding_tax_filer_error_min: "Withholding Tax (Filer) must be greater than 0",
  management_taxation_add_withholding_tax_filer_error_max: "Withholding Tax (Filer) must be less than 100",
  management_taxation_add_withholding_tax_filer_error_decimal_limit: "Withholding Tax (Filer) can be up to 2 decimal places",
  management_taxation_add_withholding_tax_non_filer: "Withholding Tax (Non-Filer)",
  management_taxation_add_withholding_tax_non_filer_error: "Withholding Tax (Non-Filer) is required",
  management_taxation_add_withholding_tax_non_filer_error_min: "Withholding Tax (Non-Filer) must be greater than 0",
  management_taxation_add_withholding_tax_non_filer_error_max: "Withholding Tax (Non-Filer) must be less than 100",
  management_taxation_add_withholding_tax_non_filer_error_decimal_limit: "Withholding Tax (Filer) can be up to 2 decimal places",

  management_exclusion_detail_text: "Exclusion Details",
  management_exclusion_name_error: "Exclusion Name is required",
  management_exclusion_LOB_error: "Line of business is required",
  management_exclusion_type: "Exclusion Type",
  management_exclusion_coverage_parent: "Parent Exclusion",
  management_exclusion_select_parent: "Select Parent",

  management_admin_listing_title: "Admin Expense",
  management_admin_listing_line_of_business: "Line of Business",
  management_admin_listing_admin_expense: "Admin Expense",
  management_admin_add_title: "Admin Expense",
  management_admin_view_action_bar_search: "Search",

  management_services_view_action_bar_search: "Search",
  management_services_listing_title: "Services",
  management_services_name: "Name",
  management_services_contribution_mode: "Contribution Mode",
  management_services_service_type: "Service Type",
  management_services_service_free: "Free",
  management_services_service_paid: "Paid",
  management_services_price_type: "Price Type",
  management_services_line_of_business: "Line of Business",
  management_services_providers: "Service Providers",
  management_services_sub_services: "Sub-Services",
  management_services_last_update: "Last Updated",

  management_services_info_title: "Information",
  management_vfs_plan_info_title: "VFS Plan Information",
  management_services_price_setup_title: "Price Setup",
  management_services_sub_services_title: "Sub-Service",
  management_services_title: "Roles",

  management_services_sub_services_view_action_bar_search: "Search",
  management_services_sub_services_listing_title: "Sub-Service",
  management_services_sub_services_listing_name: "Sub-Service Name",
  management_services_sub_services_listing_description: "Description",
  management_services_sub_services_listing_benefit: "Benefits",
  management_services_sub_services_add_sub_services_name_required_error: "Sub Service Name is required",
  management_services_sub_services_add_sub_services_name_length_error: "Sub Service must be less than 100 characters",
  management_services_sub_services_add_sub_services_name_empty_space_error: "Sub Service Name is invalid",
  management_services_sub_services_add_sub_services_description_required_error: "Description is required",
  management_services_sub_services_add_sub_services_description_empty_space_error: "Description is invalid",
  management_services_sub_services_add_sub_services_description_length_error: "Description must be less than 250 characters",

  management_services_add_info_service_name: "Service Name",
  management_services_add_info_service_provider: "Service Provider",
  management_services_add_info_benefit: "Benefit",
  management_services_add_info_currency: "Currency",
  management_services_add_info_type: "Max Limit",
  management_services_add_info_takaful_provider: "Takaful Provider",
  management_services_add_info_service_name_required_error: "Service Name is required",
  management_services_add_info_service_name_length_error: "Service must be less than 70 characters",
  management_services_add_info_description_required_error: "Description is required",
  management_services_add_info_description_length_error: "Description must be less than 500 characters",
  management_services_add_info_service_provider_required_error: "Service Provider is required",
  management_services_add_info_contribution_mode_required_error: "Contribution mode is required",
  management_services_add_info_price_type_mode_required_error: "Price type is required",
  management_services_add_info_line_of_business_required_error: "Line of Business is required",

  management_admin_add_admin_cost_min: "Admin Cost (Min)",
  management_admin_add_admin_cost_min_error: "Admin Cost (Min) is required",
  management_admin_add_admin_cost_max: "Admin Cost (Max)",
  management_admin_add_admin_cost_max_error: "Admin Cost (Max) is required",
  management_admin_add_admin_cost_min_greater_then_max_error: "Admin Cost (Min) should be less then Admin Cost (Max)",
  management_admin_add_admin_cost_max_less_then_min_error: "Admin Cost (Max) should be greater then Admin Cost (Min)",
  management_admin_add_admin_cost_min_error_min_amount: "Admin Cost (Min) can't be less then 0",
  management_admin_add_admin_cost_min_error_max_percentage: "Admin Cost (Min) can't be more then 100",
  management_admin_add_admin_cost_max_error_min_amount: "Admin Cost (Max) can't be less then 0",
  management_admin_add_admin_cost_max_error_max_percentage: "Admin Cost (Max) can't be more then 100",
  management_admin_add_admin_cost_min_error_length: "Admin Cost (Mix) can't be more then 6 digits",
  management_admin_add_admin_cost_max_error_length: "Admin Cost (Man) can't be more then 6 digits",
  management_admin_add_admin_cost_min_error_decimal_limit: "Admin Cost (Mix) can be up to 2 decimal places",
  management_admin_add_admin_cost_max_error_decimal_length: "Admin Cost (Man) can be up to 2 decimal places",

  management_sale_point_title: "Sale Point",
  management_sale_point_sales_category: "Sales Category",
  management_sale_point_sales_category_error: "Sales Category is required",
  management_sale_point_sales_medium: "Sales Medium",
  management_sale_point_sales_medium_error: "Sales Medium is required",

  management_sale_point_partner: "Partner",
  management_sale_point_partner_error: "Partner is required",
  management_sale_point_search_placeholder: "Search",

  management_feature_heading: "Feature",
  management_feature_view_action_bar_search: "Search",

  management_user_takaful_bazaar_user_title: "User List",
  management_user_takaful_bazaar_user_assign_role: "Assign Role",
  management_user_takaful_bazaar_user_assign_role_sub_title: "Takaful Bazaar User",
  management_user_takaful_bazaar_user_incentive_management: "Incentive Management",
  management_user_takaful_bazaar_user_sale_point: "Sale Point",
  management_user_takafulbazaar_user_team_lead: "Team Lead",
  management_user_takafulbazaar_user_filer_non_filer: "Filer / Non-Filer",
  management_user_takafulbazaar_user_filer_view_role_form: "Role",
  management_user_takafulbazaar_user_withholding_tax_form: "WithHolding Tax",
  management_user_takafulbazaar_user_withholding_tax_form_error_min: "Withholding Tax must be greater than 0",
  management_user_takafulbazaar_user_withholding_tax_form_error_max: "Withholding Tax must be less than 100",
  management_user_takafulbazaar_user_withholding_tax_form_error_decimal_limit: "Withholding Tax can be up to 2 decimal places",

  management_user_takafulbazaar_user_filer_non_filer_error: "Filer/Non-Filer is required",
  management_user_takafulbazaar_user_roles_error: "Role is required",

  management_user_takaful_bazaar_user_incentive_management_month_year: "Month - Year",
  management_user_takaful_bazaar_user_incentive_management_target_range: "Target Range",
  management_user_takaful_bazaar_user_incentive_management_team_target_range: "Team Target Range",
  management_user_takaful_bazaar_user_incentive_management_mark_as_default: "Mark as Default",
  management_user_takaful_bazaar_user_incentive_management_target_range_min: "Target Range Min",
  management_user_takaful_bazaar_user_incentive_management_target_range_min_error: "Minimum is required",
  management_user_takaful_bazaar_user_incentive_management_target_range_min_greater_then_max_error: "Minimum should be less then Maximum",
  management_user_takaful_bazaar_user_incentive_management_target_range_max: "Target Range Max",
  management_user_takaful_bazaar_user_incentive_management_target_range_max_error: "Maximum is required",
  management_user_takaful_bazaar_user_incentive_management_target_range_negative_error: "Range should be positive",

  management_user_takaful_bazaar_user_incentive_management_target_range_max_less_then_min_error: "Maximum should be greater then Minimum",
  management_user_takaful_bazaar_user_incentive_management_target_range_min_less_then_max_error: "Minimum should be less than the Maximum",
  management_user_takaful_bazaar_user_incentive_management_incentive: "Incentive (%)",
  management_user_takaful_bazaar_user_incentive_management_incentive_error: "Incentive is required",
  management_user_takaful_bazaar_user_incentive_management_incentive_min_max_error: "Incentive must between 0 - 100",
  management_user_takaful_bazaar_user_incentive_management_agent_gross_commission: "Agent Gross Commission",
  management_user_takaful_bazaar_user_incentive_management_factoring: "Factoring (%)",
  management_user_takaful_bazaar_user_incentive_management_factoring_error: "Factoring is required",
  management_user_takaful_bazaar_user_incentive_management_factoring_min_max_error: "Factoring must between 0 - 100",
  management_user_takaful_bazaar_user_incentive_management_pre_tax_commission: "Pre Tax Commission",
  management_user_takaful_bazaar_user_incentive_management_post_tax_commission: "Post Tax Commission",
  management_user_takaful_bazaar_user_incentive_management_withholding_tax: "Withholding Tax",
  management_user_takaful_bazaar_user_incentive_management_decimal_no_allowed_error: "Must not have more than 2 decimals",
  management_user_takaful_bazaar_user_incentive_management_incentive_two_decimal_only_error: "Incentive should be two decimal only",
  management_user_takaful_bazaar_user_incentive_management_lead_gross_commission: "Lead Gross Commission",
  management_user_takaful_bazaar_user_incentive_management_conflicting_range: "Target Range is conflicting",
  management_user_takaful_bazaar_user_incentive_management_future_month_error: "Please select Future Month Entry",
  management_user_takaful_bazaar_user_incentive_management_current_previous_error: "Please select Current or Previous Month Entry",

  management_user_takaful_bazaar_user_sale_point_select_sale_point_error: "Please select sale point",
  management_user_takaful_bazaar_user_sale_point_select_sale_point: "Select Salepoint",

  management_services_add_price_setup_title: "Service Price Setup",
  management_services_add_price_setup_stamp_duty: "Stamp Duty",
  management_services_add_price_setup_fif: "FIF",
  management_services_add_price_setup_with_holding_tax_filer: "Withholding Tax (Filer)",
  management_services_add_price_setup_with_holding_tax_non_filer: "Withholding Tax (Non-Filer)",
  management_services_add_price_setup_with_sales_tax: "Sales Tax",

  management_services_add_price_setup_stamp_duty_required_error: "Input field is missing",
  management_services_add_price_setup_provision_type_required_error: "Provision Type is missing",
  management_services_add_price_setup_stamp_duty_negative_error: "Negative Values are not allowed",
  management_services_add_price_setup_stamp_duty_decimal_not_allowed_error: "Up to two decimal values allowed",
  management_services_add_price_setup_stamp_duty_five_digits_allowed_error: "Up to five digits allowed only",
  management_services_add_price_setup_stamp_duty_two_digits_allowed_error: "Up to two digits allowed only",
  management_services_add_price_setup_stamp_duty_one_decimal_allowed_error: "Up to two decimal allowed only",

  management_services_add_price_setup_fif_required_error: "Input field is missing",
  management_services_add_price_setup_fif_negative_error: "Negative Values are not allowed",
  management_services_add_price_fif_digits_allowed_error: "Up to two digits allowed only",
  management_services_add_price_setup_fif_one_decimal_allowed_error: "Up to two decimal allowed only",

  management_services_add_price_setup_with_holding_tax_filer_duty_required_error: "Input field is missing",
  management_services_add_price_setup_with_holding_tax_filer_negative_error: "Negative Values are not allowed",
  management_services_add_price_with_holding_tax_filer_digits_allowed_error: "Up to two digits allowed only",
  management_services_add_price_setup_with_holding_tax_filer_one_decimal_allowed_error: "Up to two decimal allowed only",

  management_services_add_price_setup_with_holding_tax_non_filer_required_error: "Input field is missing",
  management_services_add_price_setup_with_holding_tax_non_filer_negative_error: "Negative Values are not allowed",
  management_services_add_price_with_holding_tax_non_filer_digits_allowed_error: "Up to two digits allowed only",
  management_services_add_price_setup_with_holding_tax_non_filer_one_decimal_allowed_error: "Up to two decimal allowed only",

  management_services_add_price_setup_sales_tax_required_error: "Input field is missing",
  management_services_add_price_setup_sales_tax_negative_error: "Negative Values are not allowed",
  management_services_add_price_setup_sales_tax_digits_allowed_error: "Up to two digits allowed only",
  management_services_add_price_setup_sales_tax_one_decimal_allowed_error: "Up to two decimal allowed only",

  management_services_add_price_setup_incentive_title: "Incentive",
  management_services_add_price_setup_incentive_min: "Incentive(Min)",
  management_services_add_price_setup_incentive_max: "Incentive(Max)",
  management_services_add_price_setup_built_in_incentive: "Built-in Incentive",
  management_services_add_price_setup_base_rate: "Base Rate",
  management_services_add_price_setup_one_month_installment_range: "1 Month Installment Range",
  management_services_add_price_setup_eleven_month_installment_range: "11 Month Installment Range",
  management_services_add_price_setup_admin_cost_title: "Admin Cost",
  management_services_add_price_setup_pricing_title: "Pricing",
  management_services_add_price_setup_add_row: "Add Row",
  management_services_add_price_setup_listing_age_bracket: "Age Bracket",
  management_services_add_price_setup_listing_listing_price: "Listing Price",
  management_services_add_price_setup_listing_total_admin_and_taxes: "Total Admin & Taxes",
  management_services_add_price_setup_listing_gross_contribution: "Gross Contribution",
  management_services_add_price_setup_listing_incentive_range: "Incentive Range",
  management_services_add_price_setup_listing_selling_price_range: "Selling Price Range",

  management_services_add_price_setup_incentive_min_required_error: "Input field is required",
  management_services_add_price_setup_incentive_min_maximum_error_in_percentage: "Minimum-Incentive must be equal to or less than two digits",
  management_services_add_price_setup_incentive_min_minimum_error_in_percentage: "Negative Values are not allowed",
  management_services_add_price_setup_incentive_min_minimum_decimal_error_in_percentage: "Minimum-Incentive must contain only 2 decimal points",
  management_services_add_price_setup_incentive_min_maximum_error_in_non_percentage: "Minimum-Incentive must be equal to or less than five digits",
  management_services_add_price_setup_incentive_min_decimal_error_in_non_percentage: "Up to two decimal values are allowed ",

  management_services_add_price_setup_incentive_max_required_error: "Input field is required",
  management_services_add_price_setup_incentive_max_minimum_error_in_percentage: "Negative Values are not allowed",
  management_services_add_price_setup_incentive_max_maximum_error_in_percentage: "Maximum-Incentive must be equal to or less than two digits",
  management_services_add_price_setup_incentive_max_minimum_decimal_error_in_percentage: "Maximum-Incentive must be contain only 2 decimal points",
  management_services_add_price_setup_incentive_max_decimal_error_in_non_percentage: "Up to two decimal values are allowed",
  management_services_add_price_setup_incentive_max_maximum_error_in_non_percentage: "Maximum-Incentive must be equal to or less than five digits",
  management_services_add_price_setup_tb_incentive_max_maximum_error_in_non_percentage: "Maximum-Incentive must be equal to or less than six digits",
  management_services_add_price_setup_tb_incentive_max_decimal_error_in_non_percentage: "Decimal values are not allowed",

  management_services_add_price_setup_base_rate_max_required: "Maximum base rate is required",
  management_services_add_price_setup_base_rate_max_positive_error: "Maximum base rate must be positive",
  management_services_add_price_setup_base_rate_max_minimum_error: "Maximum base rate must be equal to or less than six digits",
  management_services_add_price_setup_base_rate_max_minimum_decimal_error: "Decimal values are not allowed",

  management_services_add_price_setup_selling_min_required: "Minimum Selling Rate is required",
  management_services_add_price_setup_selling_min_positive_error: "Minimum Selling Rate must be positive",
  management_services_add_price_setup_selling_min_minimum_error: "Minimum Selling Rate must be equal to or less than six digits",
  management_services_add_price_setup_selling_min_decimal_error: "Decimal values are not allowed",

  management_services_add_price_setup_selling_max_required: "Maximum Selling Rate is required",
  management_services_add_price_setup_selling_max_positive_error: "Maximum Selling Rate must be positive",
  management_services_add_price_setup_selling_max_maximum_error: "Maximum Selling Rate must be equal to or less than six digits",
  management_services_add_price_setup_selling_max_decimal_error: "Decimal values are not allowed",
  management_services_add_price_setup_selling_max_greater_than_min_error:
    "Maximum Selling Rate must be equal to or greater than  Minimum Selling Rate",

  management_services_add_price_setup_incentive_max_greater_than_min_error: "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  management_services_add_price_setup_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  management_services_add_price_setup_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  management_services_add_price_setup_incentive_built_in_required_error: "Input field is required",
  management_services_add_price_setup_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  management_services_add_price_setup_incentive_built_in_minimum_decimal_error_in_percentage:
    "Built-In Incentive must be contain only 2 decimal points",
  management_services_add_price_setup_incentive_built_in_maximum_error_in_non_percentage:
    "Built-In Incentive must be equal to or less than Six digits",
  management_services_add_price_setup_incentive_built_in_decimal_error_in_non_percentage: "Up to two decimal values are allowed",
  management_services_add_price_setup_incentive_built_in_minimum_error_in_percentage: "Negative Values are not allowed",

  management_services_add_price_setup_min_admin_cost_required_error: "Input field is required",
  management_services_add_price_setup_min_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  management_services_add_price_setup_min_admin_cost_maximum_error_in_percentage:
    "Minimum Admin Cost must be must be equal to or less than two digits",
  management_services_add_price_setup_min_admin_cost_minimum_decimal_error_in_percentage: "Minimum Admin cost can be contain 2 decimal points",
  management_services_add_price_setup_min_admin_cost_maximum_error_in_non_percentage: "Minimum Admin Cost must be equal to or less than Five digits",
  management_services_add_price_setup_min_admin_cost_decimal_error_in_non_percentage: "Decimal value are not allowed ",

  management_services_add_price_setup_max_admin_cost_required_error: "Input field is required",
  management_services_add_price_setup_max_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  management_services_add_price_setup_max_admin_cost_maximum_error_in_percentage:
    "Maximum Admin Cost must be must be equal to or less than two digits",
  management_services_add_price_setup_max_admin_cost_minimum_decimal_error_in_percentage: "Maximum Admin cost can be contain 2 decimal points",
  management_services_add_price_setup_max_admin_cost_maximum_error_in_non_percentage: "Maximum Admin Cost must be equal to or less than Five digits",
  management_services_add_price_setup_max_admin_cost_decimal_error_in_non_percentage: "Decimal values are not allowed",
  management_services_add_price_setup_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  management_services_add_price_setup_max_admin_cost_greater_than_min_error:
    "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  management_services_add_price_setup_grid_min_age_required_error: "Input field is required",
  management_services_add_price_setup_grid_min_age_minimum_error_in_year: "Negative values are not allowed",
  management_services_add_price_setup_grid_min_age_maximum_error_in_year: "Minimum Age must be must be equal to or less than two digits",
  management_services_add_price_setup_grid_min_age_decimal_error: "Decimal values are not allowed",
  management_services_add_price_setup_min_age_maximum_digits_error_in_days: "Minimum Age must be equal to or less than Three digits",
  management_services_add_price_setup_min_age_maximum_value_error_in_days: "Minimum Age must be equal to or less than 365",

  management_services_add_price_setup_grid_max_age_required_error: "Input field is required",
  management_services_add_price_setup_grid_max_age_minimum_error_in_year: "Negative values are not allowed",
  management_services_add_price_setup_grid_max_age_decimal_error: "Decimal values are not allowed",
  management_services_add_price_setup_grid_max_age_maximum_error_in_year: "Maximum Age must be must be equal to or less than two digits",
  management_services_add_price_setup_max_age_maximum_digits_error_in_days: "Maximum Age must be equal to or less than Three digits",
  management_services_add_price_setup_max_age_maximum_value_error_in_days: "Maximum Age must be equal to or less than 365",
  management_services_add_price_setup_max_age_value_type_id_different_from_min_age_value_type_id_err:
    "Maximum Age Duration type must be same as Minimum Age Duration type",
  management_services_add_price_setup_max_age_greater_than_min_error: "Maximum Age must be equal to or greater than  Minimum Age",
  management_services_add_price_setup_max_age_duration_not_same_min_age_duration_error_in_days:
    "Maximum Age duration type must be same as Minimum age duration type",

  management_services_add_price_setup_max_age_range_conflict_error: "Duplicate entry",

  management_services_add_price_setup_grid_listing_price_required_error: "Input field is required",
  management_services_add_price_setup_grid_listing_price_minimum_error: "Negative values are not allowed",
  management_services_add_price_setup_grid_listing_price_maximum_error_in_percentage: "Listing Price must be equal to or less than two digits",
  management_services_add_price_setup_grid_listing_price_minimum_decimal_error_in_percentage: "Listing Price must be contain only 1 decimal points",
  management_services_add_price_setup_grid_listing_price_maximum_error_in_non_percentage: "Listing Price must be equal to or less than seven digits",
  management_services_add_price_setup_grid_listing_price_decimal_error_in_non_percentage: "Decimal values are not allowed",
  management_service_add_price_setup_max_age_range_conflict_error: "Duplicate Entry",

  management_services_add_price_setup_duration_type_required_error: "Duration type is required",
  health_management_list_management_finance_generate: "Generate",
  health_management_list_management_finance_payment_status: "Payment Status",
  health_management_list_management_finance_payment_status_required: "Payment Status is Required",
  health_management_list_management_finance_reset: "Reset",
  health_management_list_management_finance_date_range: "Date Range",
  health_management_list_management_finance_date_range_required_error: "Date Range is Required",
  health_management_list_management_finance_line_of_business: "Line Of Business",

  management_payment_method_listing_title: "Payment Method",
  management_payment_method_name: "Name",
  management_payment_method_name_error: "Name is required",
  management_payment_method_sale_points_error: "Please select atleast 1 sale point",
  management_payment_method_sale_points: "Sale Point",
  management_payment_method_last_updated: "Last Updated",
  management_payment_method_action: "Action",

  management_payment_gateway_listing_title: "Payment Gateway",
  management_payment_gateway_name: "Name",
  management_payment_gateway_method: "Method",
  management_payment_gateway_last_updated: "Last Updated",
  management_payment_gateway_action: "Action",

  management_transaction_cost_title: "Transaction",
  management_transaction_cost_listing_title: "Transaction Cost",
  management_transaction_cost_payment_gateway: "Payment Gateway",
  management_transaction_cost_sales_tax: "Sales Tax",
  management_transaction_cost_payment_method: "Payment Method",
  management_transaction_cost_last_updated: "Last Updated",
  management_transaction_cost_action: "Action",
  management_transaction_cost_label: "Transaction cost",
  management_transaction_cost_payment_gateway_required: "Payment gateway is required.",
  management_transaction_cost_method: "Method",
  management_transaction_cost_payment_method_required: "Payment method is required.",
  management_transaction_cost_slab_range_required: "Slab Range (Min-Max)",
  management_transaction_cost_charges_required: "Charges",
  management_transaction_cost_slab_minimum_required_error_message: "Slab minimum value must be greater than zero.",
  management_transaction_cost_slab_must_be_not_be_in_another_slab_required_error_message: "Slab must not be in the range of another slab.",
  management_transaction_cost_slab_maximum_required_error_message: "Slab maximum value must be greater than zero.",
  management_transaction_cost_slab_maximum_greater_tan_minimum_required_error_message: "Slab maximum value must be greater than slab minimum.",
  management_transaction_cost_charged_required_error_message: "Charges are required.",
  management_transaction_cost_charged_must_not_be_less_than_zero_required_error_message: "Charges must not be negative values.",
  management_transaction_cost_charged_must_not_be_empty: "Charges must not be empty.",
  management_transaction_cost_transaction_cost_must_not_be_empty: "Transaction cost must not be empty.",
  management_transaction_cost_sales_tax_must_not_be_empty: "Sales tax must not be empty.",
  management_transaction_cost_transaction_cost_error_message: "Transaction cost is required.",
  management_transaction_cost_transaction_cost_must_not_be_zero_error_message: "Transaction must be greater than zero.",
  management_transaction_sales_tax_cost_error_message: "Sales tax must be in between 0 to 100.",
  management_transaction_transaction_cost_error_message: "Transaction cost must be in between 0 to 100.",
  management_transaction_transaction_cost_two_decimal_error_message: "Transaction cost should be two decimal only",
  management_transaction_sales_tax_two_decimal_error_message: "Sales tax should be two decimal only",
  management_transaction_payment_gateway_placeholder: "Select payment gateway",
  management_transaction_payment_method_placeholder: "Select payment method",
  management_transaction_slab_min_placeholder: "Minimum slab",
  management_transaction_slab_max_placeholder: "Maximum slab",
  management_transaction_slab_charges_placeholder: "Charges",
  management_transaction_sales_tax_placeholder: "Sales tax",
  management_transaction_transaction_cost_placeholder: "Transaction cost",

  management_state_title: "",
  management_state_state_state_name: "Region/Province",
  management_state_state_code: "State Code",
  management_state_country: "Country",
  management_state_last_updated: "Last Updated",
  management_state_add_state_modal_title: "Add Region/Province",
  management_state_edit_state_modal_title: "Edit Region/Province",

  management_state_country_label: "Countries",
  management_state_country_required: "Country is required",
  management_state_country_placeholder: "Select Country",

  management_state_region_label: "Region/Province",
  management_state_state_code_label: "State Code",
  management_state_state_name_required: "Region/Province is required",
  management_state_state_name_max_char_required: "Region/Province length must not be greater than 50",
  management_state_state_code_required: "State code is required",
  management_state_state_code_max_char_required: "State code length must not be greater than 5"
};
